import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Theme, withStyles, createStyles, Divider, Typography} from '@material-ui/core'
import { Alert, Stack } from '@mui/material'
import { PrimaryButton, TeriaryButton } from './buttons'
import AquantCancelIcon from '../../assets/aq-cancel.svg'
import {ReactComponent as AlertRedIcon} from '../../assets/alert-red.svg'
import './GeneralDialog.css'

interface IGeneralDialogProps {
  open: boolean
  onClose: () => void
  onSave: () => void
  title?: string
  text?: string
  applyText?: string
  saveDisabled?: boolean
  redApplyBtn?: boolean
  alertText?: string
  children?: JSX.Element | JSX.Element[];
}

export const DialogCard = withStyles((theme: Theme) => createStyles({
  paper: {
      borderRadius: '14px',
      minWidth: '40%'
  }
}))(Dialog)

export const GeneralDialog = ({open, onClose, onSave, title, text, applyText, saveDisabled, alertText, redApplyBtn = false, children}: IGeneralDialogProps) => {

    const redBtnStyle = redApplyBtn ? { backgroundColor: '#FF6262', color: 'white' } : undefined
    return (<DialogCard open={open} onClose={onClose}>
              <Stack className='DialogTitleContainer' direction='row'>
                <Typography className='DialogTitle'>{title ? title : "Save Changes"}</Typography>
                <img src={AquantCancelIcon} onClick={()=>onClose()} alt='cancel icon' style={{cursor: 'pointer'}} />
              </Stack>

              <Divider />
              
              <DialogContent style={{padding: 0, overflow: 'hidden'}}>
                <Stack className='DialogContentContainer'>
                  <DialogContentText>
                    {alertText && <Alert className='DialogAlert' severity="error" icon={<AlertRedIcon />}>{alertText}</Alert>}
                    <Typography className='DialogText'>{text ? text : "Do you want to save changes?"}</Typography>
                  </DialogContentText>
                  {children}
                </Stack>
                
              </DialogContent>
              <DialogActions className='DialogActions'>
                <TeriaryButton onClick={onClose} className='TeriaryButton' disableElevation disableFocusRipple disableRipple disableTouchRipple>Cancel</TeriaryButton>
                <PrimaryButton onClick={onSave} className='PrimaryButton' disabled={saveDisabled} style={redBtnStyle} disableElevation disableFocusRipple disableRipple disableTouchRipple>{applyText ? applyText : 'Save'}</PrimaryButton>
              </DialogActions>
            </DialogCard>)
}